import { CircularProgress } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { Case } from '../../../../shared/api/hscan/case';
import maximizeIcon from '../../assets/icons/icon_maximize.svg';
import {
  BlueRoundedButtonWithIcon,
  BlueRoundedThinButton,
  ButtonContainer,
} from '../../common/components/BlueRoundedButton';
import { ButtonWithIcon } from '../../common/components/ButtonWithIcon';
import {
  DownloadButtonProps,
  DownloadCaseButton,
} from '../../common/components/DownloadCaseButton';
import { DetailButton } from '../../common/components/ImageDetailButton';
import { WindowSize, WindowSizeContext } from '../../hooks/windowSizeHook';
import { MaxImageModal } from '../ImageList/MaxImageModal';

import { ResetSessionIdContext } from './SessionIdContext';

const ButtonWrapper = styled.div`
  display: flex;
  align-self: center;
  margin-top: 16px;
  column-gap: 10px;
  row-gap: 8px;

  ${p =>
    p.theme.isMobile &&
    `
    column-gap: 3px;
    font-size: 12px;
    `}
`;

interface PreviewCaseInfoButtonsProps {
  caseInfo: Case;
}
export const PreviewImageDetailButtons = (
  props: PreviewCaseInfoButtonsProps,
) => {
  const { caseInfo } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.shareToPatientImageList',
  });

  const windowSize = useContext(WindowSizeContext);
  const isMobile = windowSize === WindowSize.MOBILE;

  const [openModal, setOpenModal] = useState(false);

  return (
    <ButtonWrapper>
      <DetailButton caseInfo={caseInfo} />
      <ButtonWithIcon
        $padding="5px"
        $fontSize={isMobile ? '12px' : undefined}
        icon={maximizeIcon}
        text={`${t('maximizeButton.label')}`}
        onClick={() => setOpenModal(true)}
      />
      <MaxImageModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        caseInfo={caseInfo}
      />
    </ButtonWrapper>
  );
};

export const PreviewDownloadCaseButton = ({
  caseInfo,
}: PreviewCaseInfoButtonsProps) => {
  const resetSessionId = useContext(ResetSessionIdContext);

  return (
    <DownloadCaseButton
      caseIds={[caseInfo.caseId]}
      DownloadButton={PreviewDownloadCaseButtonContent}
      onErrorDownload={resetSessionId}
    />
  );
};

const PreviewDownloadCaseButtonContent = ({
  isDownloading,
  onClick,
}: DownloadButtonProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.shareToPatientImageList',
  });

  const windowSize = useContext(WindowSizeContext);
  const isMobile = windowSize === WindowSize.MOBILE;

  return isMobile ? (
    <BlueRoundedButtonWithIcon
      maxWidth="136px"
      onClick={isDownloading ? undefined : onClick}>
      {isDownloading ? (
        <CircularProgress size={30} style={{ color: 'white' }} />
      ) : (
        t('downloadButton.mobile')
      )}
    </BlueRoundedButtonWithIcon>
  ) : (
    <ButtonContainer>
      <BlueRoundedThinButton onClick={isDownloading ? undefined : onClick}>
        {isDownloading ? (
          <CircularProgress size={16} style={{ color: 'white' }} />
        ) : (
          t('downloadButton.pc')
        )}
      </BlueRoundedThinButton>
    </ButtonContainer>
  );
};
